<div
  class="charts d-flex align-items-center flex-column"
  *ngIf="(isMobileViewService.isMobileView$() | async) === false; else mobileView"
>
  <common-mojo-expandable-card
    [expandable]="(elementsJobFun$ | async).length > 7 || (elementsDep$ | async).length > 7"
    [isExpanded]="expanded"
    (toggle)="toggleExpand()"
    [noPadding]="true"
    [collapsedHeight]="'18rem'"
    style="width: 100%"
  >
    <div
      class="chart-block"
      [ngClass]="{'not-expandable': !((elementsJobFun$ | async).length > 7 || (elementsDep$ | async).length > 7)}"
    >
      <div class="chart-block-section">
        <p class="chart-block-title">REFERRALS BY BUSINESS UNITS</p>
        <div class="chart-wrapper">
          <mojo-pie-chart
            *ngIf="(isLoaded$ | async); else isLoadingElementsFunID"
            [elements]="elementsJobFun$ | async"
            (selectionChange)="functionSelected($event)"
          >
          </mojo-pie-chart>
          <ng-template #isLoadingElementsFunID>
            <mat-spinner
              [diameter]="48"
              [strokeWidth]="4"
              class="loader"
            ></mat-spinner>
          </ng-template>
          <div
            class="data-points"
            *ngIf="(elementsJobFun$ | async) as elements"
          >
            <ul>
              <li *ngFor="let element of elements">
                <div class="data-entry">
                  <div class="data-entry-label">
                    <div
                      class="circle"
                      [ngStyle]="{'background-color': element.color}"
                    ></div>
                    <div>{{element.label}}</div>
                  </div>
                  <div><b>{{element.value}}</b></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="chart-block-section">
        <p class="chart-block-title">REFERRALS BY DEPARTMENTS</p>
        <div class="chart-wrapper">
          <mojo-pie-chart
            [elements]="elementsDep$ | async"
            (selectionChange)="departmentSelected($event)"
            *ngIf="(isLoaded$ | async); else isLoadingElementsDepID"
          >
          </mojo-pie-chart>
          <div
            class="data-points"
            *ngIf="(elementsDep$ | async) as elements"
          >
            <ul>
              <li *ngFor="let element of elements">
                <div class="data-entry">
                  <div class="data-entry-label">
                    <div
                      class="circle"
                      [ngStyle]="{'background-color': element.color}"
                    ></div>
                    <div>{{element.label}}</div>
                  </div>
                  <div><b>{{element.value}}</b></div>
                </div>
              </li>
            </ul>
          </div>
          <ng-template #isLoadingElementsDepID>
            <mat-spinner
              [diameter]="48"
              [strokeWidth]="4"
              class="loader"
            ></mat-spinner>
          </ng-template>
        </div>
      </div>
    </div>
  </common-mojo-expandable-card>
</div>
<ng-template #mobileView>
  <div class="charts d-flex align-items-center">
    <common-mojo-expandable-card
      [expandable]="(elementsJobFun$ | async).length > 3 || (elementsDep$ | async).length > 3"
      [isExpanded]="expandedFun"
      (toggle)="toggleExpandFun()"
      [noPadding]="true"
      [collapsedHeight]="'23rem'"
      style="width: 100%; margin-bottom: 2rem"
    >
      <div
        class="chart-block"
        [ngClass]="{'not-expandable': !((elementsJobFun$ | async).length > 7 || (elementsDep$ | async).length > 7)}"
      >
        <div class="chart-block-section">
          <p class="chart-block-title">REFERRALS BY BUSINESS UNITS</p>
          <div class="chart-wrapper">
            <mojo-pie-chart
              *ngIf="(isLoaded$ | async); else isLoadingElementsFunID"
              [elements]="elementsJobFun$ | async"
              (selectionChange)="functionSelected($event)"
            >
            </mojo-pie-chart>
            <ng-template #isLoadingElementsFunID>
              <mat-spinner
                [diameter]="48"
                [strokeWidth]="4"
                class="loader"
              ></mat-spinner>
            </ng-template>
            <div
              class="data-points"
              *ngIf="(elementsJobFun$ | async) as elements"
            >
              <ul>
                <li *ngFor="let element of elements">
                  <div class="data-entry">
                    <div class="data-entry-label">
                      <div
                        class="circle"
                        [ngStyle]="{'background-color': element.color}"
                      ></div>
                      <div>{{element.label}}</div>
                    </div>
                    <div><b>{{element.value}}</b></div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </common-mojo-expandable-card>
    <common-mojo-expandable-card
      [expandable]="(elementsJobFun$ | async).length > 3 || (elementsDep$ | async).length > 3"
      [isExpanded]="expandedDep"
      (toggle)="toggleExpandDep()"
      [noPadding]="true"
      [collapsedHeight]="'23rem'"
      style="width: 100%"
    >
      <div
        class="chart-block"
        [ngClass]="{'not-expandable': !((elementsJobFun$ | async).length > 7 || (elementsDep$ | async).length > 7)}"
      >
        <div class="chart-block-section">
          <p class="chart-block-title">REFERRALS BY DEPARTMENTS</p>
          <div class="chart-wrapper">
            <mojo-pie-chart
              [elements]="elementsDep$ | async"
              (selectionChange)="departmentSelected($event)"
              *ngIf="(isLoaded$ | async); else isLoadingElementsDepID"
            >
            </mojo-pie-chart>
            <div
              class="data-points"
              *ngIf="(elementsDep$ | async) as elements"
            >
              <ul>
                <li *ngFor="let element of elements">
                  <div class="data-entry">
                    <div class="data-entry-label">
                      <div
                        class="circle"
                        [ngStyle]="{'background-color': element.color}"
                      ></div>
                      <div>{{element.label}}</div>
                    </div>
                    <div><b>{{element.value}}</b></div>
                  </div>
                </li>
              </ul>
            </div>
            <ng-template #isLoadingElementsDepID>
              <mat-spinner
                [diameter]="48"
                [strokeWidth]="4"
                class="loader"
              ></mat-spinner>
            </ng-template>
          </div>
        </div>
      </div>
    </common-mojo-expandable-card>
  </div>
</ng-template>
